// extracted by mini-css-extract-plugin
export default {"iframeBox":"styles_iframeBox__pGHEt","iframe":"styles_iframe__xsnZe"};